import { B2B_CHECKOUT_PAGE_KEY } from '../constants';

const pt = {
  [B2B_CHECKOUT_PAGE_KEY]: {
    NAME_LABEL: 'Nome',
    REQUIRED_FIELD: 'Campo obrigatório',
    REQUIRED_NAME: 'Nome obrigatório',
    INVALID_NAME: 'O nome é inválido',
    LAST_NAME_LABEL: 'Sobrenome',
    REQUIRED_LAST_NAME: 'Sobrenome obrigatório',
    INVALID_LAST_NAME: 'O sobrenome é inválido',

    // Payment Errors
    INSUFFICIENT_FUNDS:
      'Nosso sistema nos diz que você não tem fundos suficientes.',
    EXPIRED_CARD: 'Seu cartão está expirado, entre em contato com seu banco',
    INVALID_INFO_CARD: 'Seu cartão é incorreto, tente novamente',
    INVALID_CARD: 'Seu cartão é inválido, tente novamente',
    CATCH_MESSAGE: 'O pagamento não foi processado. Tente outra vez',
  },
};

export default pt;
